export const settings = {
	ThingDangerSettings: import('./ThingDangerSettings'),
	ThingDisplayPictureSettings: import('./ThingDisplayPictureSettings'),
	ThingGeneralSettings: import('./ThingGeneralSettings'),
	ThingProductDetailSettings: import('./ThingProductDetailSettings '),
	ThingProductSettings: import('./ThingProductSettings'),
	ThingWifiSettings: import('./ThingWifiSettings'),
};
